var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { GEMINI_USAGE_CATEGORY_COLORS_CONFIG, GEMINI_USAGE_CATEGORY_TRANSLATION_KEYS } from '@web/config';
import { applyMinBarHeight } from '@web/utility/charts';
import { GEMINI_USAGE_CATEGORIES } from '@workalizer/shared/enums';
export var geminiUsageCategoryDataKey = function (prefix, category) {
    return "".concat(prefix).concat(GEMINI_USAGE_CATEGORY_TRANSLATION_KEYS[category]
        .charAt(0)
        .toUpperCase()).concat(GEMINI_USAGE_CATEGORY_TRANSLATION_KEYS[category].slice(1));
};
export var resolveGeminiUsageCategoryFromChartDataKey = function (dataKey) {
    return GEMINI_USAGE_CATEGORIES.find(function (category) {
        return geminiUsageCategoryDataKey('current', category) === dataKey ||
            geminiUsageCategoryDataKey('previous', category) === dataKey ||
            geminiUsageCategoryDataKey('team', category) === dataKey;
    });
};
export var getGeminiUsageCategoryCountFromRow = function (dataKey, row) {
    var _a;
    var category = resolveGeminiUsageCategoryFromChartDataKey(dataKey);
    if (!category || !row) {
        return 0;
    }
    var counts = dataKey.startsWith('team')
        ? row.teamCounts
        : dataKey.startsWith('previous')
            ? row.previousCounts
            : row.currentCounts;
    return (_a = counts === null || counts === void 0 ? void 0 : counts[category]) !== null && _a !== void 0 ? _a : 0;
};
export var GEMINI_USAGE_CATEGORY_BAR_CHART_CONFIGS = {
    previous: GEMINI_USAGE_CATEGORIES.map(function (category) { return ({
        dataKey: geminiUsageCategoryDataKey('previous', category),
        fill: GEMINI_USAGE_CATEGORY_COLORS_CONFIG[category].prevChartColor,
        stackId: 'previous'
    }); }),
    current: GEMINI_USAGE_CATEGORIES.map(function (category) { return ({
        dataKey: geminiUsageCategoryDataKey('current', category),
        fill: GEMINI_USAGE_CATEGORY_COLORS_CONFIG[category].chartColor,
        stackId: 'current'
    }); }),
    team: GEMINI_USAGE_CATEGORIES.map(function (category) { return ({
        dataKey: geminiUsageCategoryDataKey('team', category),
        fill: GEMINI_USAGE_CATEGORY_COLORS_CONFIG[category].teamChartColor,
        stackId: 'team'
    }); })
};
var appendCategoryCounts = function (row, prefix, counts) {
    for (var _i = 0, GEMINI_USAGE_CATEGORIES_1 = GEMINI_USAGE_CATEGORIES; _i < GEMINI_USAGE_CATEGORIES_1.length; _i++) {
        var category = GEMINI_USAGE_CATEGORIES_1[_i];
        row[geminiUsageCategoryDataKey(prefix, category)] = counts[category];
    }
};
var buildGeminiUsageCategoryChartRow = function (_a) {
    var segmentId = _a.segmentId, name = _a.name, current = _a.current, previous = _a.previous, team = _a.team, periodLabels = _a.periodLabels;
    var row = {
        name: name,
        segmentId: segmentId,
        currentPeriodComparisonLabel: periodLabels === null || periodLabels === void 0 ? void 0 : periodLabels.currentPeriodComparisonLabel,
        previousPeriodLabel: periodLabels === null || periodLabels === void 0 ? void 0 : periodLabels.previousPeriodLabel,
        period: periodLabels === null || periodLabels === void 0 ? void 0 : periodLabels.period,
        dateFrom: periodLabels === null || periodLabels === void 0 ? void 0 : periodLabels.dateFrom,
        dateTo: periodLabels === null || periodLabels === void 0 ? void 0 : periodLabels.dateTo,
        currentCounts: current,
        previousCounts: previous
    };
    appendCategoryCounts(row, 'previous', previous);
    appendCategoryCounts(row, 'current', current);
    if (team) {
        row.teamCounts = team;
        appendCategoryCounts(row, 'team', team);
    }
    return row;
};
export var buildGeminiUsageCategoryBreakdownChartData = function (segments, periodLabels) {
    return segments.map(function (segment) {
        var _a, _b, _c, _d;
        return buildGeminiUsageCategoryChartRow({
            segmentId: segment.id,
            name: segment.name,
            current: segment.current,
            previous: segment.previous,
            team: segment.team,
            periodLabels: {
                currentPeriodComparisonLabel: (_b = (_a = periodLabels === null || periodLabels === void 0 ? void 0 : periodLabels.currentPeriodComparisonLabel) !== null && _a !== void 0 ? _a : segment.period) !== null && _b !== void 0 ? _b : segment.name,
                previousPeriodLabel: (_d = (_c = segment.previousPeriodLabel) !== null && _c !== void 0 ? _c : periodLabels === null || periodLabels === void 0 ? void 0 : periodLabels.previousPeriodLabel) !== null && _d !== void 0 ? _d : '',
                period: segment.period,
                dateFrom: segment.dateFrom,
                dateTo: segment.dateTo
            }
        });
    });
};
export var buildGeminiUsageCategoryByAppChartData = function (apps, getAppLabel, periodLabels) {
    return apps.map(function (segment) {
        var row = buildGeminiUsageCategoryChartRow({
            segmentId: segment.appName,
            name: getAppLabel(segment.appName),
            current: segment.current,
            previous: segment.previous,
            team: segment.team,
            periodLabels: periodLabels
        });
        return __assign(__assign({}, row), { appName: segment.appName });
    });
};
export var GEMINI_USAGE_CATEGORY_PREVIOUS_STACK_DATA_KEYS = GEMINI_USAGE_CATEGORY_BAR_CHART_CONFIGS.previous.map(function (config) { return config.dataKey; });
export var GEMINI_USAGE_CATEGORY_CURRENT_STACK_DATA_KEYS = GEMINI_USAGE_CATEGORY_BAR_CHART_CONFIGS.current.map(function (config) { return config.dataKey; });
export var GEMINI_USAGE_CATEGORY_TEAM_STACK_DATA_KEYS = GEMINI_USAGE_CATEGORY_BAR_CHART_CONFIGS.team.map(function (config) { return config.dataKey; });
export var buildGeminiUsageCategoryTeamStripePatternId = function (insightType, dataKey) { return "".concat(insightType, "_").concat(dataKey); };
export var buildGeminiUsageCategoryTeamChartConfig = function (showTeamAverage, insightType) {
    var previousKeys = GEMINI_USAGE_CATEGORY_BAR_CHART_CONFIGS.previous.map(function (config) { return config.dataKey; });
    var currentKeys = GEMINI_USAGE_CATEGORY_BAR_CHART_CONFIGS.current.map(function (config) { return config.dataKey; });
    var teamKeys = GEMINI_USAGE_CATEGORY_BAR_CHART_CONFIGS.team.map(function (config) { return config.dataKey; });
    if (!showTeamAverage) {
        return {
            tooltipSeriesOrder: __spreadArray(__spreadArray([], previousKeys, true), currentKeys, true),
            stripeSwatchColors: undefined,
            teamStripePatterns: [],
            teamStripePatternId: function (dataKey) {
                return buildGeminiUsageCategoryTeamStripePatternId(insightType, dataKey);
            },
            separatorAfterDataKeys: undefined
        };
    }
    return {
        tooltipSeriesOrder: __spreadArray(__spreadArray(__spreadArray([], previousKeys, true), currentKeys, true), teamKeys, true),
        stripeSwatchColors: Object.fromEntries(GEMINI_USAGE_CATEGORY_BAR_CHART_CONFIGS.team.map(function (config, index) { return [
            config.dataKey,
            GEMINI_USAGE_CATEGORY_COLORS_CONFIG[GEMINI_USAGE_CATEGORIES[index]]
                .teamChartColor
        ]; })),
        teamStripePatterns: GEMINI_USAGE_CATEGORY_BAR_CHART_CONFIGS.team.map(function (config, index) { return ({
            patternId: buildGeminiUsageCategoryTeamStripePatternId(insightType, config.dataKey),
            chartColor: GEMINI_USAGE_CATEGORY_COLORS_CONFIG[GEMINI_USAGE_CATEGORIES[index]]
                .teamChartColor
        }); }),
        teamStripePatternId: function (dataKey) {
            return buildGeminiUsageCategoryTeamStripePatternId(insightType, dataKey);
        },
        separatorAfterDataKeys: [
            geminiUsageCategoryDataKey('current', GEMINI_USAGE_CATEGORIES[GEMINI_USAGE_CATEGORIES.length - 1])
        ]
    };
};
export var calculateGeminiUsageCategoryChartMaxValue = function (chartData, showTeamAverage) {
    return Math.max.apply(Math, __spreadArray(__spreadArray([], chartData.flatMap(function (row) {
        return GEMINI_USAGE_CATEGORIES.flatMap(function (category) {
            var _a, _b, _c;
            return __spreadArray([
                Number((_a = row[geminiUsageCategoryDataKey('previous', category)]) !== null && _a !== void 0 ? _a : 0),
                Number((_b = row[geminiUsageCategoryDataKey('current', category)]) !== null && _b !== void 0 ? _b : 0)
            ], (showTeamAverage
                ? [Number((_c = row[geminiUsageCategoryDataKey('team', category)]) !== null && _c !== void 0 ? _c : 0)]
                : []), true);
        });
    }), false), [0], false));
};
export var applyGeminiUsageCategoryChartMinBarHeights = function (chartData, showTeamAverage, minBarHeight) {
    var _a, _b, _c;
    for (var _i = 0, chartData_1 = chartData; _i < chartData_1.length; _i++) {
        var row = chartData_1[_i];
        for (var _d = 0, GEMINI_USAGE_CATEGORIES_2 = GEMINI_USAGE_CATEGORIES; _d < GEMINI_USAGE_CATEGORIES_2.length; _d++) {
            var category = GEMINI_USAGE_CATEGORIES_2[_d];
            row[geminiUsageCategoryDataKey('previous', category)] = applyMinBarHeight(Number((_a = row[geminiUsageCategoryDataKey('previous', category)]) !== null && _a !== void 0 ? _a : 0), minBarHeight);
            row[geminiUsageCategoryDataKey('current', category)] = applyMinBarHeight(Number((_b = row[geminiUsageCategoryDataKey('current', category)]) !== null && _b !== void 0 ? _b : 0), minBarHeight);
            if (showTeamAverage) {
                row[geminiUsageCategoryDataKey('team', category)] = applyMinBarHeight(Number((_c = row[geminiUsageCategoryDataKey('team', category)]) !== null && _c !== void 0 ? _c : 0), minBarHeight);
            }
        }
    }
};
export var buildGeminiUsageCategoryByAppExportRows = function (data, t, getAppLabel, includeTeamAverage) {
    if (includeTeamAverage === void 0) { includeTeamAverage = false; }
    return data.apps.map(function (segment) {
        var _a;
        var row = (_a = {},
            _a[t('app.apps.gemini.usageCategoryByApp.export.app')] = getAppLabel(segment.appName),
            _a);
        for (var _i = 0, GEMINI_USAGE_CATEGORIES_3 = GEMINI_USAGE_CATEGORIES; _i < GEMINI_USAGE_CATEGORIES_3.length; _i++) {
            var category = GEMINI_USAGE_CATEGORIES_3[_i];
            var categoryLabel = t("app.apps.gemini.summary.categories.".concat(GEMINI_USAGE_CATEGORY_TRANSLATION_KEYS[category]));
            row["".concat(t('export.current'), " ").concat(categoryLabel)] =
                segment.current[category];
            row["".concat(t('export.previous'), " ").concat(categoryLabel)] =
                segment.previous[category];
            if (includeTeamAverage && segment.team) {
                row["".concat(t('export.teamAverage'), " ").concat(categoryLabel)] =
                    segment.team[category];
            }
        }
        return row;
    });
};
export var buildGeminiActionBreakdownExportRows = function (data, t, segmentLabelKey, includeTeamAverage) {
    if (includeTeamAverage === void 0) { includeTeamAverage = false; }
    return data.segments.map(function (segment) {
        var _a;
        var row = (_a = {},
            _a[t(segmentLabelKey)] = segment.name,
            _a);
        for (var _i = 0, GEMINI_USAGE_CATEGORIES_4 = GEMINI_USAGE_CATEGORIES; _i < GEMINI_USAGE_CATEGORIES_4.length; _i++) {
            var category = GEMINI_USAGE_CATEGORIES_4[_i];
            var categoryLabel = t("app.apps.gemini.summary.categories.".concat(GEMINI_USAGE_CATEGORY_TRANSLATION_KEYS[category]));
            row["".concat(t('export.current'), " ").concat(categoryLabel)] =
                segment.current[category];
            row["".concat(t('export.previous'), " ").concat(categoryLabel)] =
                segment.previous[category];
            if (includeTeamAverage && segment.team) {
                row["".concat(t('export.teamAverage'), " ").concat(categoryLabel)] =
                    segment.team[category];
            }
        }
        return row;
    });
};
